/**
* @file 搜索
* @author Ice(chenzhouji@baidu.com)
*/
import {useState, useRef, useCallback} from 'react';
import {filter, concat} from 'lodash';
import {useClickOutside} from '@huse/click-outside';
import {FlattenItem} from './flattenTree';

const queryFactory = (items: FlattenItem[]) => (keyword: string) => {
    if (!keyword) {
        return [];
    }

    return filter(items, item => {
        const regx = new RegExp(keyword, 'i');
        const content = concat(item.parentNames, item.name).join('');
        return regx.test(content);
    });
};

export default (dataSource: FlattenItem[]) => {
    const query = queryFactory(dataSource);
    const domRef = useRef<HTMLDivElement>(null);
    const [visible, togglePanel] = useState<boolean>(false);
    const [keyword, setKeyword] = useState<string>('');
    const [result, updateResult] = useState<FlattenItem[]>([]);
    useClickOutside(domRef, () => togglePanel(false));

    const handleInputChange = useCallback(
        e => {
            const value = e.target.value || '';
            const show = !!value;
            setKeyword(value);
            updateResult(query(value));
            togglePanel(show);
        },
        [togglePanel, updateResult, setKeyword]
    );

    return {domRef, visible, keyword, result, handleInputChange};
}
